module.exports = __webpack_public_path__ + "static/media/ic-price.910c5739.svg";